module.exports = __webpack_public_path__ + "media/images/weather/101_day-a7155cbc2a42f96d72bb853e9f27c43d.png";